module.exports = __webpack_public_path__ + "img/resume.b0f2b888.svg";